import React from 'react'
import { FuseLayout, FuseTheme } from '@fuse'
import Provider from 'react-redux/es/components/Provider'
import { Router } from 'react-router-dom'
import jssExtend from 'jss-extend'
import history from '@history'
import { Auth } from './auth'
import store from './store'
import AppContext from './AppContext'
import routes from './fuse-configs/routesConfig'
import { create } from 'jss'
import rtl from 'jss-rtl'
import { CrispProvider } from 'commons/useCrisp'
import { UnleashProvider } from 'commons/useUnleash'
import {
  StylesProvider,
  jssPreset,
  createGenerateClassName,
} from '@material-ui/styles'
import { LocalizationProvider } from './translations/intl-context'
import LoadingSpinner from './components/LoadingSpinner'
import AppAccessControl from './auth/AppAccessControl'
import AppLimboAccessControl from './auth/AppLimboAccessControl'
import AppRestrictAccessControl from './auth/AppRestrictAccessControl'
import AppSetup from './AppSetup'
import NotificationDialog from './components/NotificationDialog'

import { PartnerBrowerSetup } from 'commons/usePartner'
import { initializeGoogleAnalytics } from 'libs/google-analytics'
import BackgroundProgressBarImportProcess from 'app/main/subscribersV4/AddSubscibers/components/newImport/BackgroundProgressBarImportProcess'
// import CrispButtonManager from './components/CrispChatManager'
import WarningDialog from './componentV4/WarningDialog'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import DialogFeatureHighlights from './componentV4/FeatureHighlights/DialogFeatureHighlights'
import { SocketProvider } from './SocketContext'

const queryClient = new QueryClient()

const jss = create({
  ...jssPreset(),
  plugins: [...jssPreset().plugins, jssExtend(), rtl()],
  insertionPoint: document.getElementById('jss-insertion-point'),
})

// Include the Crisp code here, without the <script></script> tags
// disable crish chat for now
// window.$crisp = []
// window.CRISP_WEBSITE_ID = '609ead80-9a02-426f-868d-155f11ee0775'
// ;(function () {
//   var d = document
//   var s = d.createElement('script')

//   s.src = 'https://client.crisp.chat/l.js'
//   s.async = 1
//   d.getElementsByTagName('head')[0].appendChild(s)
// })()

const generateClassName = createGenerateClassName()

initializeGoogleAnalytics()

const App = () => {
  return (
    <AppContext.Provider
      value={{
        routes,
      }}
    >
      <StylesProvider jss={jss} generateClassName={generateClassName}>
        <Provider store={store}>
          <QueryClientProvider client={queryClient}>
            <LocalizationProvider>
              <CrispProvider>
                <UnleashProvider>
                  <Auth>
                    <Router history={history}>
                      <AppAccessControl routes={routes}>
                        <AppRestrictAccessControl routes={routes}>
                          <AppLimboAccessControl routes={routes}>
                            <AppSetup>
                              <SocketProvider>
                                <PartnerBrowerSetup>
                                  <FuseTheme>
                                    <FuseLayout />
                                    <LoadingSpinner />
                                    <BackgroundProgressBarImportProcess />
                                    {/* <CrispButtonManager /> */}
                                    <NotificationDialog />
                                    <WarningDialog />
                                    <DialogFeatureHighlights />
                                  </FuseTheme>
                                </PartnerBrowerSetup>
                              </SocketProvider>
                            </AppSetup>
                          </AppLimboAccessControl>
                        </AppRestrictAccessControl>
                      </AppAccessControl>
                    </Router>
                  </Auth>
                </UnleashProvider>
              </CrispProvider>
            </LocalizationProvider>
          </QueryClientProvider>
        </Provider>
      </StylesProvider>
    </AppContext.Provider>
  )
}

export default App
